// websocketMiddleware.js
import { setNotificationCount } from "../redux/notificationsSlice";
import api from "../utils/api";

const websocketMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  // Listen for the handleNewChange action from WebSocket
  if (action.type === "websocket/handleNewChange") {
    const { data } = action.payload;

    console.log("WebSocket middleware triggered by new change:", data);

    // Fetch all notification counts globally
    fetchAddressChangeRequests(store.dispatch);
    fetchCancellationRequests(store.dispatch);
    fetchInspectionRequests(store.dispatch);

    // You can add more global actions here for other types of data
    // Example:
    // fetchOtherNotifications(store.dispatch);
    // updateGlobalStats(store.dispatch);
  }

  return result;
};

// Global function to fetch address change requests
const fetchAddressChangeRequests = async (dispatch) => {
  try {
    console.log("Fetching address change requests globally...");

    const response = await api.get(
      "/admin/subscriptions/changeAddress-requests",
      {
        params: {
          page: 1,
          limit: 1000, // Use a large limit to get total count accurately
        },
      }
    );

    if (response.data.status === "success") {
      // Update Redux store with notification count globally
      dispatch(
        setNotificationCount({
          key: "requestEditAddress",
          count: response.data.totalDocuments || 0,
        })
      );

      console.log("✅ Global address change requests updated:", {
        totalDocuments: response.data.totalDocuments,
        timestamp: new Date().toISOString(),
      });
    }
  } catch (error) {
    console.error("❌ Error in global fetch address change requests:", error);

    // Optionally dispatch an error action
    // dispatch(setGlobalError({
    //   type: 'fetchAddressRequests',
    //   error: error.message
    // }));
  }
};

// Global function to fetch cancellation requests
const fetchCancellationRequests = async (dispatch) => {
  try {
    console.log("Fetching cancellation requests globally...");

    const response = await api.get("/refunds", {
      params: {
        page: 1,
        limit: 1000, // Use a large limit to get total count accurately
        status: "pending",
      },
    });

    if (response.data.status === "success") {
      dispatch(
        setNotificationCount({
          key: "cancellationRequests",
          count: response.data.totalCount || 0,
        })
      );

      console.log("✅ Global cancellation requests updated:", {
        totalCount: response.data.totalCount,
        timestamp: new Date().toISOString(),
      });
    }
  } catch (error) {
    console.error("❌ Error in global fetch cancellation requests:", error);
  }
};

// Global function to fetch inspection requests
const fetchInspectionRequests = async (dispatch) => {
  try {
    console.log("Fetching inspection requests globally...");

    const response = await api.get("/preview-requests", {
      params: {
        page: 1,
        limit: 1000, // Use a large limit to get total count accurately
        status: "pending",
      },
    });

    if (response.data.status === "success") {
      dispatch(
        setNotificationCount({
          key: "inspectionRequests",
          count: response.data.totalCount || 0,
        })
      );

      console.log("✅ Global inspection requests updated:", {
        totalCount: response.data.totalCount,
        timestamp: new Date().toISOString(),
      });
    }
  } catch (error) {
    console.error("❌ Error in global fetch inspection requests:", error);
  }
};

export default websocketMiddleware;
